import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import AdminPortal from './index';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AdminPortal />
  </StrictMode>
);
